import GlobalStoreService from "../services/global-store.service";
import ChatBotApiService from '../services/chatbot-api.service';

export class RefreshTokenService {

    static refreshLoginToken = () => {
        return new Promise((resolveRefreshLoginToken,rejectRefreshLoginToken)=>{
            const method = "GET";
            let app_reference = GlobalStoreService.get("APP_CONTEXT")
            const uri =
            "https://api.myairtelapp.bsbportal.in/myairtelapp/v2/home/mainAccCard?density=XXHDPI";
            const payload = "";
            let appHeaders = app_reference.getHeaders(
                method,
                uri,
                payload
            );
            appHeaders = String(appHeaders).replace(/\n/g, "");
            appHeaders = JSON.parse(appHeaders);
            const headers = {
                "x-bsy-dt": String(appHeaders["x-bsy-dt"]).replace(/\n/g, ""),
                "x-bsy-utkn1": String(appHeaders["x-bsy-utkn"]).replace(/\n/g, ""),
                "x-bsy-did": String(appHeaders["x-bsy-did"]).replace(/\n/g, "")
            };
        
            let newappHeaders = app_reference.getHeaders(
                method,
                "https://www.airtel.in/app/wl-service/airtel-digital-profile/rest/customer/profile/v2/rtn/fetch",
                ""
            );
            newappHeaders = String(newappHeaders).replace(/\n/g, "");
            newappHeaders = JSON.parse(newappHeaders);
            headers["x-bsy-utkn2"] = String(newappHeaders["x-bsy-utkn"]).replace(/\n/g, "");
        
            ChatBotApiService.getChatTokenForApp(headers).then((result) => {
            if(result && result.access_token) {
                GlobalStoreService.set("loggedInToken", "Bearer" + result.access_token);
                resolveRefreshLoginToken();
            }
            },err=>{
                console.log(err);
                rejectRefreshLoginToken();
            });
        })
        
    }

    static refreshBasicToken = () => {
        return new Promise((resolveRefreshBasicToken,rejectRefreshBasicToken)=>{
            ChatBotApiService.getChatToken().then((result) => {
                if(result && result.access_token) {
                    GlobalStoreService.set("basicToken", "Bearer" + result.access_token);
                    resolveRefreshBasicToken();
                }    
            },err=>{
                console.log(err);
                rejectRefreshBasicToken();
            });
        })
        
    }
}


// WEBPACK FOOTER //
// ./src/services/refresh-token.service.js